module.exports = __webpack_public_path__ + "img/horizontal_3_3_0.a6150092.png";